import { getClient } from "@/api/getClient.ts";
import { useEffect, useState } from "react";
import { Client } from "@/types/client.ts";
import { TListener } from "@/types";

let _client: Client | null = null;
let listeners: TListener<Client>[] = [];

const loadFromLocalStorage = () => {
  _client = JSON.parse(localStorage.getItem("client") ?? "null");
};
const saveToLocalStorage = () => {
  localStorage.setItem("client", JSON.stringify(_client));
};

const fetchClient = async () => {
  try {
    const response = await getClient();
    _client = response.data;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    //TODO
  }
};

const updateListeners = () => {
  if (listeners.length > 0 && _client) {
    listeners.forEach((listener) => listener(_client!));
  }
};

const setThemeColor = () => {
  document.documentElement.style.setProperty(
    "--primary",
    _client!.theme.main_color,
  );
  document.documentElement.style.setProperty(
    "--secondary",
    _client!.theme.secondary_color,
  );
};

const init = async () => {
  loadFromLocalStorage();
  updateListeners();
  await fetchClient();
  setThemeColor();
  updateListeners();
  saveToLocalStorage();
};

init();

setInterval(() => {
  fetchClient();
  updateListeners();
  saveToLocalStorage();
}, 60 * 1000);

export const useClient = () => {
  const [state, setState] = useState(_client);
  useEffect(() => {
    listeners.push(setState);
    return () => {
      listeners = listeners.filter((listener) => listener !== setState);
    };
  }, []);
  return state;
};
